import { CountryCode } from "libphonenumber-js";
import { Suspense } from "react";

import { PhoneNumber } from "@/components/General/PhoneNumber/phoneNumber.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    phoneNumber: string;
    country?: CountryCode;
    asLink?: string;
};

const PhoneNumberContainer = ({ phoneNumber, country, asLink }: Props) => {
    const { t } = useGranite();

    return (
        <Suspense fallback={<p>{t("common.loading")}</p>}>
            <PhoneNumber
                phoneNumber={phoneNumber}
                asLink={asLink === "true"}
                ISOcountryCode={country}
            />
        </Suspense>
    );
};

export { PhoneNumberContainer };
